<template>
  <div class="rang-rank" v-show="cars.length > 0" @click.stop>
    <div class="rang-rank__container">
      <!-- 标题栏 -->
      <div class="rang-rank__title">
        <div class="rang-rank__heading">Rang Rank</div>
        <a :href="allCarsLink" class="rang-rank__view">
          <div class="rang-rank__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="rang-rank__icon" alt="">
        </a>
      </div>

      <!-- 内容区域 -->
      <div class="rang-rank__content">
        <!-- 加载状态 - 临时隐藏 -->
        <!-- <div v-if="loading" class="rang-rank__loading">
          <div class="rang-rank__loading-text">Loading...</div>
        </div> -->

        <!-- 正常内容显示 -->
        <template>
          <!-- 卡片展示区域 -->
          <div class="rang-rank__cards">
            <a v-for="(car, index) in displayedCars" :key="`car-${index}`" class="rang-rank__card"
              :href="getDetailLink(car)" :data-empty="car.isEmpty">
              <!-- 车辆图片 -->
              <img :src="car.image" class="rang-rank__pic" alt="">

              <!-- 加速时间 -->
              <div class="rang-rank__speed">
                <div class="rang-rank__speed-value">
                  <div class="rang-rank__speed-number">{{ car.speedValue }}</div>
                </div>
                <div class="rang-rank__speed-label">
                  <div class="rang-rank__speed-text">0–60-MPH Times</div>
                </div>
              </div>

              <!-- 品牌和名称 -->
              <div class="rang-rank__info">
                <div class="rang-rank__info-left">
                  <div class="rang-rank__logo">
                    <img :src="car.logo" alt="">
                  </div>
                  <div class="rang-rank__text">
                    <div class="rang-rank__model">{{ car.model }}</div>
                    <div class="rang-rank__brand">{{ car.brand }}</div>
                  </div>
                </div>
              </div>
            </a>
          </div>

          <!-- 导航按钮和指示器 - 仅在PC端显示且有多页时显示 -->
          <div class="rang-rank__nav" v-if="deviceType !== 'mobile' && totalPages > 1">
            <div class="rang-rank__nav-arrow rang-rank__nav-prev" @click="prevPage">
              <img src="@/assets/arrow-left-blue.svg" alt="Previous">
            </div>

            <div class="rang-rank__nav-dots">
              <div v-for="n in totalPages" :key="`dot-${n}`" class="rang-rank__nav-dot"
                :class="{'rang-rank__nav-dot--active': currentPage === n}" @click="goToPage(n)">
              </div>
            </div>

            <div class="rang-rank__nav-arrow rang-rank__nav-next" @click="nextPage">
              <img src="@/assets/arrow-right-blue.svg" alt="Next">
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarRangRank',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    }),
    allCarsLink () {
      const currentChannel = this.$route.params.channel;
      const query = this.$route.query;
      const queryString = Object.keys(query).length > 0 ? `?${new URLSearchParams(query).toString()}` : '';
      let path = '/car-list';
      if (currentChannel) {
        path = `/${currentChannel}${path}`;
      }
      return `${path}${queryString}`;
    },
    // 计算当前显示的卡片
    displayedCars () {
      // 移动端展示所有车辆，不做分页
      if (this.deviceType === 'mobile') {
        return this.cars;
      }

      // PC端保持原来的分页逻辑
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const items = this.cars.slice(start, start + this.itemsPerPage);

      // The effect should be more subtle for Rang Rank
      if (items.length === 3) {
        const lastItemStyles = { ...items[0], isEmpty: true };
        items.push(lastItemStyles);
      } else if (items.length === 2) {
        const lastItemStyles = { ...items[0], isEmpty: true };
        items.push(lastItemStyles);
        items.push(lastItemStyles);
      } else if (items.length === 1) {
        const lastItemStyles = { ...items[0], isEmpty: true };
        items.push(lastItemStyles);
        items.push(lastItemStyles);
        items.push(lastItemStyles);
      }

      return items;
    },
    // 计算总页数
    totalPages () {
      return Math.ceil(this.cars.length / this.itemsPerPage);
    }
  },
  data () {
    return {
      currentPage: 1,
      itemsPerPage: 4,
      cars: [],
      loading: false,
      error: null
    }
  },
  mounted () {
    this.fetchRangRankData();
  },
  methods: {
    // 从API获取排名数据
    async fetchRangRankData () {
      try {
        this.loading = true;
        this.error = null;

        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};

        // 调用global.js中的getRecommendedRangRank方法获取数据
        const res = await this.$global.server.getRecommendedRangRank(themeFilters);
        if (res.code === 200) {
          // 处理API返回的数据
          const apiData = res.data || [];
          if (apiData.length > 0) {
            const processedData = apiData.map(item => {
              // 从photos字段提取第一张图片作为封面
              const photos = item.photos ? item.photos.split(',') : [];
              const firstPhoto = photos.length > 0 ? photos[0] : require('@/assets/car-recommend-img.png');

              // 返回处理后的数据，映射字段名称
              return {
                id: item.id,
                model: item.name, // API中是name字段，映射为model
                brand: item.brand,
                logo: item.logoUrl || require('@/assets/car-logo.svg'), // 使用默认logo，因为API中没有提供
                year: item.year || item.marketTime?.substring(0, 4) || '-',
                category: item.purpose || '-', // 使用purpose字段作为category
                bodyType: item.type || '-', // 使用type字段作为bodyType
                price: this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-',
                image: item.cover || firstPhoto, // 使用cover字段，如果没有则使用firstPhoto
                speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-', // 添加's'后缀
                isEmpty: false
              };
            });

            this.cars = processedData;
            console.log('[CarRangRank] 获取排名数据:', this.cars.length);
            // 重置当前页为第一页
            this.currentPage = 1;
          } else {
            // 如果没有数据，则设置为空数组
            this.cars = [];
            console.log('[CarRangRank] 没有排名数据');
          }
        } else {
          throw new Error(res.message || 'Failed to get rang rank data');
        }
      } catch (error) {
        console.error('[CarRangRank] 获取排名数据错误:', error);
        this.error = error.message || 'Failed to get rang rank data';
        this.cars = [];
      } finally {
        this.loading = false;
      }
    },

    getDetailLink (car) {
      if (!car || !car.id || car.isEmpty) {
        return '#';
      }
      const currentChannel = this.$route.params.channel;
      const formattedName = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      const query = this.$route.query;
      const queryString = Object.keys(query).length > 0 ? `?${new URLSearchParams(query).toString()}` : '';

      let path = `/cars/${formattedName}/${car.id}`;
      if (currentChannel) {
        path = `/${currentChannel}${path}`;
      }

      return `${path}${queryString}`;
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },

    // 上一页
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    // 下一页
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    // 跳转到指定页
    goToPage (page) {
      this.currentPage = page;
    },
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.rang-rank {
	padding: rem(50) rem(120);
	background: #ffffff;

	&__container {
		max-width: rem(1200);
		margin: 0 auto;
	}

	&__title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(20);
	}

	&__heading {
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		color: #050b20;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(10);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		color: #405ff2;
	}

	&__icon {
		width: rem(14);
		height: rem(14);
	}

	&__content {
		position: relative;
		width: 100%;
		// min-height: rem(300);
	}

	&__cards {
		display: flex;
		gap: rem(30);
		overflow: hidden;
	}

	&__loading {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(200);
		width: 100%;
	}

	&__loading-text {
		font-size: rem(18);
		font-weight: 700;
		color: #405ff2;
	}

	&__error {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(200);
		width: 100%;
	}

	&__error-text {
		font-size: rem(18);
		font-weight: 700;
		color: #ff0000;
	}

	&__card {
		// flex: 1 0 calc(25% - rem(15));
		width: calc((100% - rem(90)) / 4);
		position: relative;
		border: 1px solid #e9e9e9;
		border-radius: rem(12);
		overflow: hidden;
		cursor: pointer;
		aspect-ratio: 278/184;

		&[data-empty='true'] {
			visibility: hidden;
		}
	}

	&__pic {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__speed {
		position: absolute;
		top: rem(6);
		left: rem(6);
		display: flex;
		border-radius: rem(8);
		overflow: hidden;
		z-index: 2;
	}

	&__speed-value {
		background: #050b20;
		border-radius: rem(8) 0 0 rem(8);
		padding: rem(4) rem(6);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__speed-number {
		color: #ffffff;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 900;
	}

	&__speed-label {
		background: rgba(5, 11, 32, 0.5);
		border-radius: 0 rem(8) rem(8) 0;
		padding: rem(4) rem(6);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__speed-text {
		color: #ffffff;
		font-size: rem(12);
		line-height: rem(16);
		font-weight: 400;
	}

	&__info {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%);
		padding: rem(12);
	}

	&__info-left {
		display: flex;
		align-items: center;
		gap: rem(12);
	}

	&__logo {
		width: rem(36);

		height: rem(36);
		background: #fff;
		border-radius: 50%;
		padding: rem(2);
		object-fit: cover;
		overflow: hidden;
	}

	&__logo img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	&__text {
		display: flex;
		flex-direction: column;
		gap: rem(2);
	}

	&__model {
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 700;
		color: #ffffff;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	&__brand {
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		color: #ffffff;
	}

	&__nav {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-top: rem(20);
		gap: rem(20);
	}

	&__nav-dots {
		display: flex;
		gap: rem(8);
		align-items: center;
	}

	&__nav-dot {
		width: rem(8);
		height: rem(8);
		background-color: #e0e0e0;
		border-radius: 50%;
		cursor: pointer;
		transition: all 0.3s ease;

		&--active {
			background-color: #405ff2;
		}
	}

	&__nav-arrow {
		width: rem(40);
		height: rem(40);
		border-radius: 8px;
		border: 1px solid rgba(#405ff2, 0.1);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			border: 1px solid rgba(#405ff2, 0.6);
		}

		img {
			width: rem(20);
			height: rem(20);
		}
	}
}

// 移动端适配
.detect_deviece_mobile {
	.rang-rank {
		padding: rem(30) rem(16);

		&__cards {
			display: flex;
			flex-wrap: nowrap;
			overflow-x: auto;
			gap: rem(16);
			padding-bottom: rem(10);
			scrollbar-width: none;
			-ms-overflow-style: none;
			&::-webkit-scrollbar {
				display: none;
			}
			margin: 0 rem(-16);
			padding: 0 rem(16);
			width: calc(100% + rem(32));
		}

		&__view-all {
			font-size: rem(14);
			line-height: rem(14);
		}

		&__icon {
			width: rem(14);
			height: rem(14);
		}

		&__card {
			flex: 0 0 rem(278);
			height: rem(184);
			aspect-ratio: 278/184;
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.rang-rank {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.rang-rank {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
	}
}
</style> 